import { useState, useEffect } from 'react';
import { useWindowSize } from 'react-use';
import { isBrowser } from '@web3/base-utils';

const defaultScreenType = {
  isMobile: false,
  isMd: false,
  isXl: false,
  height: 0,
  width: 0,
};

export const getScreenType = (width: number, height: number) => {
  if (!isBrowser) return defaultScreenType;
  return {
    isMobile: width <= 768,
    // isTablet: width > 768 && width <= 1024,
    // isSmDesktop: width > 1024 && width <= 1200,
    // isMdDesktop: width > 1200 && width <= 1440,
    // isLgDesktop: width > 1440,

    isMd: width > 768 && width <= 1200,
    isXl: width > 1200,
    // && width <= 1920,
    // isXlDesktop: width > 2560,
    height,
    width,
  };
};

// export const initialWindowType = getScreenType();

export const useScreenType = () => {
  const { width, height } = useWindowSize();
  const [screenType, setScreenType] = useState(defaultScreenType);

  useEffect(() => {
    setScreenType(getScreenType(width, height));
  }, [width, height]);

  return screenType;
};
